import { ListOf } from 'app/effector/model'

import { ReportType } from './ReportType'

class ReportTypeList extends ListOf(ReportType) {}

export { ReportTypeList }
